/** Tags filteren op zoekterm: elk woord moet in het label voorkomen (hoofdletterongevoelig). */
export function filterTags(opties, zoek) {
  const woorden = String(zoek || '').toLowerCase().split(/\s+/).filter(Boolean);
  if (!woorden.length) return opties;
  return opties.filter((o) => {
    const l = String(o.label || '').toLowerCase();
    return woorden.every((w) => l.includes(w));
  });
}
